module.exports = __webpack_public_path__ + "img/silver.dda86086.png";